import React from 'react';

import eventBus from '../services/event-bus';

import BodyPortal from '../portals/body-portal';

import OverlayUIElement from './overlay-ui-element';

export default class Popout extends OverlayUIElement {
    static defaultProps = {
        closeFromDoc: true,
        closeOnClickOut: true,
        minHeight: 100
    }

    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible,
            zIndex: 40
        };

        this.element = null;
        this.preventClose = false;

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);
    }

    handlePopoutClick = event => {
        if (event.target.classList.contains('close-popouts')) {
            this.hide();
        } else {
            this.show();
            this.preventClose = true;
        }
    }

    handleHideFromBus = () => {
        this.hide();
    }

    show(event) {
        return new Promise(resolve => {
            if (this.state.visible) {
                resolve();
                return;
            }

            this.setState({
                visible: true
            }, () => {
                const parent = this.overlayPlaceholder ? this.overlayPlaceholder.parentNode : null;

                if (parent && this.props.width === 'inherit') {
                    this.element.style.width = `${parent.clientWidth}px`;
                }

                this.setOverlayElement(this.props.refElement || this.element, parent);
                this.handleOverlayElementShow(event);

                resolve();

                this.preventClose = true;

                document.addEventListener('click', this.handleDocClick);
                window.addEventListener('keydown', this.handleKeyDown);

                setTimeout(() => {
                    this.preventClose = false;
                });
            });

            this.props.onShow && this.props.onShow();
        })
    }

    hide() {
        if (!this.state.visible) {
            return;
        }

        this.setState({
            visible: false
        });

        this.handleOverlayElementHide();

        this.props.onHide && this.props.onHide();

        document.removeEventListener('click', this.handleDocClick);
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown(event) {
        if (!this.state.visible) {
            return;
        }

        switch (event.which) {
            case 27: // Esc
                if (this.props.closeFromDoc) {
                    this.hide();
                }
                break;

            case 13: // Enter
                this.props.onEnterPress && this.props.onEnterPress();
                break;

            default:
                return null;
        }
    }

    handleDocClick(event) {
        if (this.preventClose) {
            this.preventClose = false;

            return;
        }

        if (!this.props.closeFromDoc) {
            return;
        }

        if (!this.props.closeOnClickOut) {
            return;
        }

        if (!this.props.closeOnEveryClick && !(event.target.closest && event.target.closest('.app'))) {
            return;
        }

        this.hide();
    }

    componentDidMount() {
        const ctrl = {
            show: event => {
                return this.show(event);
            },
            hide: () => {
                this.hide();
            },
            setOverlayParentElement: element => {
                this.setOverlayParentElement(element);
                this.positionOverlayElement();
            },
            updatePosition: () => {
                this.positionOverlayElement();
            },
            isVisible: () => {
                return this.state.visible;
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }

        eventBus.once('popout:trigger:hide', this.handleHideFromBus);

        this.setOverlayElement(this.props.refElement || this.element, this.overlayPlaceholder ? this.overlayPlaceholder.parentNode : null);
    }

    componentDidUpdate(prevprops, prevState) {
        if (this.state.visible && !prevState.visible) {
            this.setState({
                zIndex: Array.from(document.querySelectorAll('body > .visible')).reduce((maxZIndex, element) => Math.max(element.style.zIndex, maxZIndex), 900) + 1
            });
        }

        if (this.state.visible) {
            this.positionOverlayElement();
        }

    }

    componentWillUnmount() {
        this.hide();
        this.handleOverlayParentDestroy();

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
        eventBus.off('popout:trigger:hide', this.handleHideFromBus);
    }

    setOverlay = element => this.overlayPlaceholder = element;
    setElement = element => this.element = element;

    render() {
        return (
            <span className="overlay-placeholder" ref={this.setOverlay}>
                {
                    this.state.visible ? (
                        <BodyPortal>
                            <div ref={this.setElement} className={'popout ' + (this.props.className || '') + (this.state.visible ? ' visible' : '')} style={{zIndex: this.state.zIndex }} onClick={this.handlePopoutClick}>
                                <div className="popout-inner nice-scroll">
                                    {this.props.children}
                                </div>
                            </div>
                        </BodyPortal>
                    ) : null
                }
            </span>
        );
    }
}
